import { LinkProps } from "react-aria-components";
import { MDSIconFunction, MDSIconKind } from "@/mds/components/icon";

export enum MDSChipVariant {
  Small = "small",
  Medium = "medium",
}

export interface MDSChipProps extends Omit<LinkProps, "children"> {
  icon?: MDSIconKind | MDSIconFunction;
  children: React.ReactNode;
  maxWidth?: number | string;
  variant?: MDSChipVariant;
  isDisabled?: boolean;
  onRemove?: () => void;
}
